<template>
  <div>
    <v-layout row justify-end class="mt-2">
      <v-flex xs2>
        <!-- <VueDatePicker
          v-model="filter.dateFrom"
          @change="onSearch"
          :placeholder="$t('เลือกวันที่เริ่ม')"
          :locale="{ lang: 'en' }"
        /> -->
        <div class="form-control" style="margin-right: 6px">
          <date-picker
            style="margin-top: 3px"
            :append-to-body="false"
            :clearable="true"
            :editable="false"
            input-class="dateSearch"
            name="DateSearch"
            v-model="filter.dateFrom"
            valueType="date"
            format="DD/MM/YYYY"
            :placeholder="$t('เลือกวันที่เริ่ม')"
            confirm
            @change="onSearch"
          >
            <template v-slot:footer="{ emit }">
              <div style="text-align: left">
                <button class="mx-btn mx-btn-text" @click="emit(new Date())">Today</button>
              </div>
            </template>
          </date-picker>
        </div>
      </v-flex>
      <v-flex xs2 class="ml-1">
        <!-- <VueDatePicker
          v-model="filter.dateTo"
          @change="onSearch"
          :placeholder="$t('เลือกวันที่สิ้นสุด')"
          :locale="{ lang: 'en' }"
        /> -->
        <div class="form-control" style="margin-right: 6px">
          <date-picker
            style="margin-top: 3px"
            @change="onSearch"
            :append-to-body="false"
            :clearable="true"
            :editable="false"
            input-class="dateSearch"
            name="DateSearch"
            v-model="filter.dateTo"
            valueType="date"
            format="DD/MM/YYYY"
            :placeholder="$t('เลือกวันที่สิ้นสุด')"
            confirm
          >
            <template v-slot:footer="{ emit }">
              <div style="text-align: left">
                <button class="mx-btn mx-btn-text" @click="emit(new Date())">Today</button>
              </div>
            </template>
          </date-picker>
        </div>
      </v-flex>

      <v-flex xs8 class="ml-1">
        <InputSearch class="mb-3" :search="filter" @clickSearch="onSearch" :placeholder="'ค้นหา'" />
      </v-flex>
    </v-layout>

    <v-layout
      wrap
      class="mt-4"
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <v-flex xs6>
        <Typography h2 bold label="คูปองที่อนุมัติแล้ว" />
      </v-flex>

      <v-flex xs6 class="text-xs-right">
        <!-- @click="exportData" -->
        <v-btn
          variant="outlined"
          v-tooltip="'ส่งออกข้อมูล'"
          @click="modalExport = true"
          :loading="loading"
          icon
          color="#BECCDB"
          style="border-radius: 50% !important"
        >
          <img src="/static/img/exportfilter.png" alt class="responsive-img" style="height: 16px" />
        </v-btn>
        <exportxlsx ref="exbtn" :value="exData" style="display: none"></exportxlsx>
      </v-flex>
    </v-layout>

    <div>
      <v-layout class="my-5" justify-center v-if="loading">
        <v-progress-circular
          :size="100"
          :width="10"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
      <v-data-table
        v-else
        hide-actions
        :headers="headers"
        :items="showData"
        item-key="name"
        class="elevation-1"
      >
        <!-- <template v-slot:headers="props">
          <tr style="background-color: #152d53; color: white">
            <th
              style="background-color: #152d53; color: yellow; text-align: left"
              v-for="(header, k) in props.headers"
              :key="header.text + k"
            >
              {{ header.text }}
            </th>
          </tr>
        </template> -->
        <template v-slot:items="props">
          <tr class="py-3 depatable">
            <td class="text-xs-left" @click.stop="clickShowLog(props.item.couponid)">
              <Typography h5 :label="props.item.productid" />
            </td>
            <td class="text-xs-left" @click.stop="clickShowLog(props.item.couponid)">
              <Typography h5 :label="shotDate(props.item.timestamp)" />
            </td>
            <td class="text-xs-left" @click.stop="clickShowLog(props.item.couponid)">
              <Typography
                style="width: 200px"
                h5
                :label="
                  props.item.membername || props.item.coordinator_name || props.item.institute_name
                "
              />
            </td>
            <td class="text-xs-left" @click.stop="clickShowLog(props.item.couponid)">
              <Typography h5 :label="props.item.id_card || '-'" />
            </td>
            <td class="text-xs-left" @click.stop="clickShowLog(props.item.couponid)">
              <Typography style="width: 200px" h5 :label="props.item.techproverdername || '-'" />
            </td>
            <td class="text-xs-left" @click.stop="clickDetail(props.item.productid)">
              <div
                style="text-decoration: underline; width: 200px; color: #26588b"
                @click="showHistory = true"
              >
                {{ props.item.productname }}
              </div>
            </td>
            <td class="text-xs-left" @click.stop="clickShowLog(props.item.couponid)">
              <Typography h5 :label="props.item.price || 0" />
            </td>
            <td class="text-xs-left" @click.stop="clickShowLog(props.item.couponid)">
              <Typography h5 :label="props.item.code || '-'" />
            </td>
            <td class="text-xs-left" @click.stop="showLog(props.item.couponid)">
              <Typography style="width: 200px" h5 :label="props.item.agencyname || '-'" />
            </td>
            <td class="text-xs-left" @click.stop="showLog(props.item.couponid)">
              <Typography h5 :label="props.item.province || '-'" />
            </td>
          </tr>
        </template>
      </v-data-table>

      <v-dialog v-model="modalExport" persistent width="400px">
        <v-card style="border-radius: 10px">
          <div class="pa-3">
            <div style="display: flex; justify-content: space-between">
              <div></div>
              <div></div>

              <v-icon style="display: flex; align-items: center" @click="modalExport = false"
                >close</v-icon
              >
            </div>
            <div class="rsu">
              <v-layout column wrap justify-center align-center class="mb-3">
                <img
                  src="/static/img/Export.png"
                  alt
                  class="responsive-img mb-1"
                  style="height: 70px"
                />
                <Typography h2 bold label="ส่งออกข้อมูล" />
                <Typography h5 medium label="คุณแน่ใจหรือไม่ว่าต้องการส่งออกข้อมูลตามที่เลือก" />
              </v-layout>
              <div class="text-xs-center">
                <div class="text-xs-center rsu">
                  <v-btn
                    :loading="loading"
                    class="rsu"
                    round
                    small
                    outline
                    color="primary"
                    @click.stop="modalExport = false"
                    >ยกเลิก</v-btn
                  >
                  <v-btn
                    class="rsu"
                    :loading="loading"
                    round
                    small
                    depressed
                    style="color: #ffef01"
                    color="primary"
                    @click.stop="exportData"
                    >ยืนยัน</v-btn
                  >
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>

      <Paginations
        @clickPagination="changepage"
        @sortPage="sortPage"
        :pageCount="pageCount"
        :numberPage="numberPage"
        :page="page"
      />

      <!-- <v-pagination
        v-if="pageCount"
        @input="changepage"
        v-model="page"
        :length="pageCount"
      ></v-pagination> -->
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import api from '@/api'
import config from '@/config'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import DatePicker from 'vue2-datepicker'

import Typography from '@/components/elements/Typography.vue'
import InputSearch from '@/components/elements/InputSearch.vue'
// import { VueDatePicker } from '@mathieustan/vue-datepicker'
import Paginations from '@/components/elements/Paginations.vue'
export default {
  components: {
    Multiselect,
    DatePicker,
    exportxlsx,
    Typography,
    InputSearch,
    // VueDatePicker,
    Paginations,
  },
  data() {
    return {
      agencyOptions: [],
      pagination: {
        sortBy: 'name',
        descending: false,
        rowsPerPage: 15,
      },
      rowsPerPage: 12,
      filter: {
        campaign: null,
        dateFrom: null,
        dateTo: null,
        nameAll: '',
      },
      exData: [],
      exDataAll: [],
      page: 1,
      modalExport: false,
      numberPage: {
        page: undefined,
      },
      loading: false,
      campaign: [],
      mainData: [],
      showData: [],
      pageTotal: 0,
      topData: [],
      top5: [],
      topOther: [],
      tafficReport: {},
      topProduct: [],
      headers: [
        { text: 'ลำดับ', align: 'left', value: 'id', sortable: false },
        { text: 'วันที่', align: 'left', value: 'date', sortable: false },
        { text: 'ชื่อ', align: 'left', value: 'buyer', sortable: false },
        {
          text: 'หมายเลขบัตรประชาชน (ของผู้ซื้อ)',
          align: 'left',
          value: 'idCard',
          sortable: false,
        },
        { text: 'ผู้ให้บริการ', align: 'left', value: 'techprovider', sortable: false },
        { text: 'ชื่อสินค้าและบริการ', align: 'left', value: 'productname', sortable: false },
        { text: 'ราคา (บาท)', align: 'left', value: 'productprice', sortable: false },
        { text: 'รหัสคูปอง', align: 'left', value: 'couponcode', sortable: false },
        // { text: 'DETAIL', align: 'left', value: 'detail' },
        { text: 'หน่วยร่วม', align: 'left', value: 'agency', sortable: false },
        { text: 'จังหวัด', align: 'left', value: 'province', sortable: false },
      ],
    }
  },
  computed: {
    techhuntUrl() {
      return config.techhuntUrl
    },
    pageCount() {
      if (this.pageTotal !== 0) {
        let count = Math.ceil(this.pageTotal / this.rowsPerPage)
        return count
      } else {
        return 0
      }
    },
    limitCom() {
      return this.rowsPerPage
    },
    offsetCom() {
      return this.page ? this.page * this.rowsPerPage - this.rowsPerPage : this.rowsPerPage
    },
  },
  async mounted() {
    // if (this.$store.state.privilege.role === 'agency') {
    //   this.agencyOptions = this.$store.state.privilege.agency
    // } else {
      await this.getAgencyData()
    // }
    this.setup()
  },
  methods: {
    getAgencyData() {
      return new Promise((resolve, reject) => {
        var data = {
          pageid: this.selectedBot.pageid,
        }

        api.getDepaAgencyMaster(data, (err, response) => {
          this.agencyOptions = response.data
          resolve()
        })
      })
    },
    async getExData() {
      this.loading = true
      let filter = {
        status: 'อนุมัติ',
      }

      if (this.filter.dateFrom) {
        filter.dateFrom = moment(this.filter.dateFrom).format('YYYY-MM-DD')
      }
      if (this.filter.dateTo) {
        filter.dateTo = moment(this.filter.dateTo).format('YYYY-MM-DD')
      }
      if (this.filter.nameAll) {
        filter.nameAll = this.filter.nameAll
      }

      // filter.limit = this.limitCom
      // filter.offset = this.offsetCom

      this.data = await api.getCouponReport(filter)
      this.exDataAll = this.data.data ? this.data.data : []
    },
    async exportData() {
      this.loading = true
      await this.getExData()
      await this.setEx()
      this.modalExport = false
      this.$refs.exbtn.exportxlsx()
      this.loading = false
    },
    // async changepage() {
    //   this.loading = true
    //   await this.getCouponReport()
    //   this.loading = false
    // },
    async changepage(pages) {
      this.page = parseInt(pages)
      this.numberPage.page = undefined
      this.loading = true
      await this.getCouponReport()
      this.loading = false
    },
    async sortPage(pages) {
      if (pages) {
        this.page = parseInt(pages)
        this.loading = true
        await this.getCouponReport()
        this.loading = false
      }
    },
    shotDate(input) {
      return moment(input).format('DD/MM/YYYY')
    },
    async setup() {
      await this.getCouponReport()
    },
    async onSearch() {
      this.getCouponReport()
    },
    async getCouponReport() {
      this.loading = true
      let filter = {
        status: 'อนุมัติ',
      }

      if (this.filter.dateFrom) {
        filter.dateFrom = moment(this.filter.dateFrom).format('YYYY-MM-DD')
      }
      if (this.filter.dateTo) {
        filter.dateTo = moment(this.filter.dateTo).format('YYYY-MM-DD')
      }
      if (this.filter.nameAll) {
        filter.nameAll = this.filter.nameAll
      }
      if (this.limitCom) {
        filter.limit = this.limitCom
      }
      filter.offset = this.offsetCom

      let agencylist = this.agencyOptions.map((agency) => {
        return agency.name
      })
      agencylist = agencylist.join(',')
      filter.agencylist = agencylist

      this.data = await api.getCouponReport(filter)
      this.loading = false
      this.showData = this.data.data ? this.data.data : []
      this.pageTotal = this.data.total ? this.data.total : []
    },
    clickDetail(id) {
      window.open(`${config.techhuntUrl}product?id=${id}`)
    },
    setEx() {
      let ex = []
      this.exDataAll.forEach((ele) => {
        let obj = {
          วันที่: moment(ele.timestamp).format('DD/MM/YYYY'),
          ผู้ซื้อ: ele.membername,
          'ผู้ขาย (Tech Provider)': ele.techproverdername,
          ชื่อสินค้า: ele.productname,
          ราคา: ele.price,
          รหัสคูปอง: ele.code,
          หน่วยร่วม: ele.agencyname,
        }
        ex.push(obj)
      })
      this.exData = ex
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  width: 120px;
  min-height: 60px;
  background-color: #182748;
  color: white;
  text-align: center;
  align-self: center;
  font-weight: bold;
}
.flex-row-end {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/view/voucherreport/approveVoucher.vue